"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.facetteSearch = void 0;
require("@progress/kendo-ui");
require("babel-polyfill");
require("jquery-ui-bundle");
require("jquery-ui-bundle/jquery-ui.css");
require("jquery-address");
require("../../../TdWebtoolkitControls/controls/ErrorDialog/ErrorDialog.js");
require("../../../TdWebtoolkitControls/controls/List/List");
const SelectionContext_1 = require("../../../TdWebtoolkitControls/controls/Menu/SelectionContext");
require("../../../TdWebtoolkitControls/controls/Preview/Preview");
require("../../../TdWebtoolkitControls/controls/PropertyPage/PropertyPage");
const PropertyPage_1 = require("../../../TdWebtoolkitControls/controls/PropertyPage/PropertyPage");
const Core_js_1 = require("../../../TdWebtoolkitControls/dependencies/ajax_solr/core/Core.js");
const synerisSolrBase_js_1 = require("../../../TdWebtoolkitControls/dependencies/ajax_solr/core/synerisSolrBase.js");
require("../../../TdWebtoolkitControls/dependencies/ajax_solr/core/ParameterStore.js");
require("../../../TdWebtoolkitControls/dependencies/ajax_solr/managers/Manager.jquery.js");
require("../../../TdWebtoolkitControls/dependencies/ajax_solr/widgets/syneris/ResultListWidget.js");
require("../../../TdWebtoolkitControls/dependencies/ajax_solr/widgets/syneris/ResultWidget.js");
require("../../../TdWebtoolkitControls/dependencies/ajax_solr/widgets/syneris/DateRangeWidget.js");
require("../../../TdWebtoolkitControls/dependencies/ajax_solr/widgets/syneris/SynerisFacetWidget.js");
require("../../../TdWebtoolkitControls/dependencies/ajax_solr/widgets/syneris/SynerisPathWidget.js");
require("../../../TdWebtoolkitControls/dependencies/ajax_solr/widgets/syneris/SynerisSearchBoxWidget.js");
require("../../../TdWebtoolkitControls/dependencies/ajax_solr/widgets/syneris/CurrentSearchWidget.js");
const Utilities_1 = require("../../../TdWebtoolkitControls/javascript/Utilities");
const $ = require("jquery");
const m = require("../SynView");
let r_coreTemplate = require("./facetteSearchCore.tmpl.htm");
/**
* Defines the type of the facet widget
*/
var FacetWidgetType;
(function (FacetWidgetType) {
    FacetWidgetType[FacetWidgetType["String"] = 1] = "String";
    FacetWidgetType[FacetWidgetType["DateRange"] = 2] = "DateRange";
    FacetWidgetType[FacetWidgetType["NumberRange"] = 3] = "NumberRange";
    FacetWidgetType[FacetWidgetType["Path"] = 5] = "Path";
})(FacetWidgetType || (FacetWidgetType = {}));
class facetteSearch extends m.SynView {
    //#endregion MEMBER VARIABLES
    //#region CONSTRUCTOR
    constructor() {
        super();
    }
    //#endregion CONSTRUCTOR
    //#region MEMBER METHODS
    //#region Inherited from SynView
    init(viewName, viewIndex, viewHtml) {
        super.init(viewName, viewIndex, viewHtml);
        this.m_solrManagers = {};
        this.icon = "fa-search-plus";
    }
    resizeControls() {
        if (this.m_$tabstrip) {
            let $header = this.m_$tabstrip.children(".k-tabstrip-items");
            let headerHeight = $header.is(":visible") ? $header.outerHeight(true) : 0;
            this.m_$tabstrip.children(".k-content").height(this.m_$container.innerHeight() - headerHeight);
            kendo.resize(this.m_$tabstrip.find(".k-splitter"), false);
        }
    }
    renderContents() {
        const that = this;
        Utilities_1.synUtil.getAJAXData({
            url: Utilities_1.synUtil.getWSUrl("ProfileFacetSearch"),
            method: "POST",
            done(data) {
                that.m_facetteProfile = data;
                let coreNames = $.map(that.m_facetteProfile.cores, (core) => { return core.name; });
                let commonFacets = $.map(data.facets, (facet) => {
                    // Common facets are facets that are valid for all cores of the facet profile
                    if (($(facet.cores).filter(coreNames)).length === coreNames.length)
                        return facet.name;
                    return undefined;
                });
                that.createTabStrip(commonFacets);
                that.resizeControls();
            }
        });
    }
    disableUI(disable = true) {
        const that = this;
        super.disableUI(disable);
        if (that.m_$preview && that.m_$preview.data("synPreview")) {
            if (disable)
                that.m_$preview.find(".k-tabstrip-items > .k-item").attr("disabled", "disabled").addClass("k-state-disabled");
            else
                that.m_$preview.find(".k-tabstrip-items > .k-item").removeAttr("disabled").removeClass("k-state-disabled");
        }
        if (disable)
            that.m_$tabstrip.find(".k-tabstrip-items > .k-item").attr("disabled", "disabled").addClass("k-state-disabled");
        else
            that.m_$tabstrip.find(".k-tabstrip-items > .k-item").removeAttr("disabled").removeClass("k-state-disabled");
        let resultContainer = that.m_$tabstrip.find(".synList");
        if (resultContainer.synList("isInitialized"))
            resultContainer.synList("lock", disable);
    }
    forceRefresh(modificationInfo) { }
    getSelectionContext() {
        if (this.m_activeCore !== "syneris")
            return super.getSelectionContext();
        const $resultContainer = this.m_$tabstrip.find("#syneris_results");
        if (!$resultContainer.synList("isInitialized"))
            return super.getSelectionContext();
        return {
            parentControl: true,
            normalParentContext: {
                parentRelId: SelectionContext_1.SpecialRelIds.Undefined
            },
            parentControlParentContext: {
                parentRelId: SelectionContext_1.SpecialRelIds.Undefined
            },
            selectedIds: $resultContainer.synList("getSelectedIds")
        };
    }
    //#endregion Inherited from SynView
    //#region Helpers
    createTabStrip(commonFacets) {
        const that = this;
        that.m_$viewPane = that.m_$container.find("#viewPane");
        that.m_$tabstrip = $("<div class='fTabStrip' style='height:100%'></div>").appendTo(that.m_$viewPane);
        if (that.m_facetteProfile.cores.length === 0) {
            that.m_$tabstrip
                .html("")
                .addClass("noFacetProfile")
                .append($("<i class='fa fa-warning'></i>"));
        }
        else {
            let ul = $("<ul></ul>").appendTo(that.m_$tabstrip);
            for (let i = 0; i < that.m_facetteProfile.cores.length; i++) {
                let div = $("<div></div>").appendTo(that.m_$tabstrip);
                let core = that.m_facetteProfile.cores[i];
                ul.append($("<li data-core='" + core.name + "' >" + kendo.htmlEncode(core.title) + "</li>"));
                let template = kendo.template(r_coreTemplate);
                let content = $(template({ coreName: core.name })).appendTo(div);
                that.addCoreSpecificLayout(core.name, content);
                that.initTabContent(core.name, content);
                that.createSolrWidgets(core.name);
            }
            let ts = that.m_$tabstrip
                .kendoTabStrip({
                animation: false,
                select(e) {
                    setTimeout(function () {
                        $(e.contentElement).find(".k-splitter").each((idx, splitter) => {
                            kendo.resize($(splitter), false);
                        });
                    });
                    // Disable menu for fs core
                    that.m_activeCore = $(e.item).attr("data-core");
                    that.MainMenu.synMenu("enable", that.m_activeCore === "syneris");
                    // update viewButtons
                    that.m_viewButtons = [];
                    let $splitter = $(e.contentElement).children(".corePane").children(".k-splitter");
                    let divs = $splitter.children("div.k-pane");
                    for (let i = 0; i < divs.length; i++)
                        that.addViewButton($(divs[i]));
                    that.raiseOnViewButtonsReady(that.m_viewButtons);
                    that.resizeControls();
                }
            }).data("kendoTabStrip");
            that.resizeControls();
            ts.select(0);
            let currentTab = ts.select();
            // If there is only one core, the tabs don't need to be visible
            if (that.m_facetteProfile.cores.length < 2)
                ts.tabGroup.css("display", "none");
            let currentCore = currentTab.attr("data-core");
            if (!that.m_solrManagers[currentCore].requireSearchText)
                that.m_solrManagers[currentCore].doRequest();
            currentTab.data("initialized", true);
            $.each(ts.tabGroup.children("li"), (idx, item) => {
                let $item = $(item);
                let core = $item.attr("data-core");
                $item.data("manager", that.m_solrManagers[core]);
                $item.data("commonFacets", commonFacets);
            });
            ts.bind("activate", that.updateTab);
            ts.bind("select", that.updateCurrentSearch);
        }
    }
    addCoreSpecificLayout(coreName, content) {
        const that = this;
        if (coreName === "syneris") {
            let paneSplitter = content.find(".paneSplitter");
            let previewDiv = $("<div />")
                .attr({
                "id": coreName + "_preview",
                "data-toggleable": "true",
                "data-toggleicon": "fa-eye"
            })
                .appendTo(paneSplitter);
            that.m_$preview = ($("<div id='Preview'></div>")).appendTo(previewDiv);
            that.m_$preview
                .on("propertyPageValuesChanged", () => {
                that.askSaveChanges(false, (saveResult) => {
                    if (saveResult === m.ViewSaveResult.Save && !that.m_saveInProgress) {
                        that.m_saveInProgress = true;
                        Utilities_1.synUtil.beginAjaxProgress(".changeBar .btn.save");
                        that.m_$preview.synPreview("getPropertyPage").synPropertyPage("commitChanges", {
                            success(currentInstance, commitResult) {
                                switch (commitResult) {
                                    case PropertyPage_1.CommitSuccess.Saved:
                                        Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("savedchanges"));
                                        that.m_$preview.synPreview("recreateAsync");
                                        break;
                                    case PropertyPage_1.CommitSuccess.Created:
                                        Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("savednew"));
                                        break;
                                    case PropertyPage_1.CommitSuccess.NoChanges:
                                        Utilities_1.synUtil.Notifications.warning(Utilities_1.synUtil.Strings.getValue("nochanges"));
                                        break;
                                    default:
                                        break;
                                }
                                that.m_saveInProgress = false;
                                that.disableUI(false);
                            },
                            cleanUp() {
                                that.m_saveInProgress = false;
                                Utilities_1.synUtil.endAjaxProgress(".changeBar .btn.save");
                            },
                            updatePropertyPageAfterCommit: true
                        });
                    }
                    else if (saveResult === m.ViewSaveResult.Cancel) {
                        that.m_$preview.synPreview("getPropertyPage").synPropertyPage("refresh");
                        that.disableUI(false);
                    }
                });
            })
                .on("propertyPageValuesReverted", () => {
                that.disableUI(false);
            })
                .synPreview({ editable: true });
        }
    }
    updateCurrentSearch(e) {
        let $oldTab = e.sender.select();
        let $newTab = $(e.item);
        // Get current search constraints of old tab that may be applied new tab
        let oldManager = $oldTab.data("manager");
        let newManager = $newTab.data("manager");
        let searchNeeded = false;
        let oldVal = oldManager.store.get("q").val();
        let newVal = newManager.store.get("q").val();
        newManager.store.get("q").val(oldVal);
        if (oldVal !== newVal)
            searchNeeded = true;
        $.each($oldTab.data("commonFacets"), (idxtmp, facet) => {
            let regex = new RegExp('^(\{!tag=[A-Za-z0-9_]+})*' + facet);
            let idx = oldManager.store.find("fq", regex);
            if (idx && idx >= 0)
                newVal = oldManager.store.get("fq")[idx].val();
            idx = newManager.store.find("fq", regex);
            if (idx && idx >= 0)
                oldVal = newManager.store.get("fq")[idx].val();
            newManager.store.removeByValue("fq", regex);
            if (newVal)
                newManager.store.addByValue("fq", newVal);
            if (newVal !== oldVal)
                searchNeeded = true;
        });
        $newTab.data("searchNeeded", searchNeeded);
    }
    updateTab(e) {
        let $item = $(e.item);
        let manager = $item.data("manager");
        if ((!$item.data("initialized") && !manager.requireSearchText) || $item.data("searchNeeded"))
            manager.doRequest();
        $item.data("initialized", true);
        $item.removeData("searchNeeded");
    }
    initTabContent(coreName, content) {
        const that = this;
        let paneConfig = {
            syneris: [
                { collapsible: true, scrollable: true, rows: 3 },
                { collapsible: false, scrollable: false },
                { collapsible: true, scrollable: false, rows: 3 }
            ],
            fs: [
                { collapsible: true, scrollable: true, rows: 3 },
                { collapsible: false, scrollable: true }
            ]
        };
        let $splitter = content.children(".paneSplitter");
        let cfg = this.getSplitterConfig($splitter);
        let panes = $.map(paneConfig[coreName], (elem, idx) => {
            let pane = $.extend(true, {}, elem);
            if (elem.rows) {
                pane.size = ((elem.rows * 100 / 12) + '%');
                delete pane.rows;
            }
            if (cfg.m_paneConfigs.length >= idx + 1)
                pane.collapsed = cfg.m_paneConfigs[idx].m_collapsed;
            return pane;
        });
        $splitter.css('border', '0').kendoSplitter({
            orientation: "horizontal",
            panes,
            resize: (e) => {
                let preview = e.sender.element.find(".synPreview");
                if (preview.length > 0)
                    preview.outerHeight(preview.parent().innerHeight()).synPreview("resize");
                that.raiseOnViewResize();
            },
        });
    }
    createSolrWidgets(coreName) {
        const that = this;
        let langCode = Utilities_1.synUtil.userLanguage.substring(0, 2);
        let facetFields = [];
        let autoCompleteFacets = [];
        if (that.m_facetteProfile.facetFields[coreName]) {
            $.each(that.m_facetteProfile.facetFields[coreName], (idx, field) => {
                let facetName = that.m_facetteProfile.facets[field].name;
                if (facetName.indexOf("spellcheck_") !== 0
                    || (langCode && (facetName === "spellcheck_" + langCode))) {
                    facetFields.push(that.m_facetteProfile.facets[field]);
                }
            });
        }
        if (that.m_facetteProfile.autocompleteFields[coreName]) {
            $.each(that.m_facetteProfile.autocompleteFields[coreName], (idx, field) => {
                autoCompleteFacets.push(that.m_facetteProfile.facets[field]);
            });
        }
        that.m_solrManagers[coreName] = that.initSolr(coreName, facetFields, that.m_facetteProfile.maxRows);
        that.m_solrManagers[coreName].requireSearchText = that.m_facetteProfile.requireSearchText || false;
        that.m_solrManagers[coreName].baseColor = that.m_facetteProfile.baseColor;
        let manager = that.m_solrManagers[coreName];
        $.each(that.m_facetteProfile.facets, (idx, facet) => {
            manager.mapSynerisField(facet.name, facet.title);
        });
        let createSection = (target, headerText, divId, widget) => {
            let div = $("<div class='optionsDiv clearfix'></div>").appendTo(target);
            div.append("<h4>" + headerText + "</h4>");
            $("<div id='" + divId + "'></div>").appendTo(div);
            div.css("display", "none");
            manager.addWidget(widget);
        };
        let widgetContainer = that.m_$tabstrip.find("#" + coreName + "_hierarchical");
        let resultContainer = that.m_$tabstrip.find("#" + coreName + "_results");
        // Add searchBox widget
        let searchBoxDiv = that.m_$tabstrip.find("#" + coreName + "_search");
        let searchBox = new Core_js_1.AjaxSolr.SynerisSearchBoxWidget({
            core: coreName,
            id: coreName + "_searchbox",
            target: "#" + coreName + "_search",
            facets: that.m_facetteProfile.facets,
            autoCompleteFacets: that.m_facetteProfile.autocompleteFields[coreName] || []
        });
        manager.addWidget(searchBox);
        // Add currentsearch widget
        createSection(widgetContainer, Utilities_1.synUtil.Strings.getValue("searchconditions"), coreName + "_currentSearch", new Core_js_1.AjaxSolr.CurrentSearchWidget({
            id: coreName + '_currentSearch',
            target: '#' + coreName + '_currentSearch',
            facets: that.m_facetteProfile.facets
        }));
        // Add facet widgets
        $.each(facetFields, (idx, facet) => {
            let divid = coreName + "_" + facet.name.replace(/\./g, '_') + "_facet";
            let facetId = coreName + "_" + facet.name;
            let target = "#" + divid;
            let widget;
            let collapseAfter = 5;
            let widgetType = that.getFacetWidgetType(facet);
            switch (widgetType) {
                case FacetWidgetType.DateRange:
                    widget = new Core_js_1.AjaxSolr.DateRangeWidget({ id: facetId, target, field: facet.name });
                    break;
                case FacetWidgetType.NumberRange:
                    // not yet implemented
                    break;
                case FacetWidgetType.Path:
                    widget = new Core_js_1.AjaxSolr.SynerisPathWidget({
                        id: facetId,
                        target,
                        field: facet.name,
                        options: facet.options
                    });
                    break;
                case FacetWidgetType.String:
                    widget = new Core_js_1.AjaxSolr.SynerisFacetWidget({
                        id: facetId,
                        target,
                        field: facet.name,
                        options: facet.options,
                        collapseAfter
                    });
                    break;
            }
            if (widget != undefined)
                createSection(widgetContainer, facet.title, divid, widget);
        });
        searchBoxDiv.find(".queryField").attr("placeholder", Utilities_1.synUtil.Strings.getValue("searchenterkeywords"));
        if (coreName === "syneris") {
            resultContainer
                .css("height", "100%")
                .off('selectionChanged').on("selectionChanged", (_evt, ids) => {
                if (that.m_$preview.data("synPreview")) {
                    if (ids.length == 1)
                        that.m_$preview.synPreview("setInstanceAsync", ids[0], true);
                    else
                        that.m_$preview.synPreview("clearView");
                }
                that.updateSelectionContext();
            })
                .off("beforeSelectionChanged").on("beforeSelectionChanged", function (evt, continueObject) {
                if (that.m_UIDisabled)
                    continueObject.continueCallback(false);
                else
                    continueObject.continueCallback(true);
            })
                .synList({
                columnOptions: {
                    layoutName: "websearch",
                    catIdDependent: true,
                    catId: 1
                },
                raiseBeforeSelectionChanged: true,
                dataItemGenerator: (ctx) => {
                    var _a, _b;
                    const results = (_b = (_a = manager.response) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.docs;
                    if (!results)
                        return Promise.resolve([]);
                    // This regex matches all fields that originate from syneris
                    let synerisFieldRegex = /_(path|[bfdisl])[m]?$/;
                    let items = [];
                    for (let i = 0; i < results.length; i++) {
                        let doc = results[i];
                        let item = {
                            id: doc["cgdocument.instanzid_i"] + "|" + doc["cgdocument.docid_i"] + "|" + doc["cgdocument.typeid_i"],
                            icon: "category=" + doc["cgdocument.typeid_i"]
                        };
                        for (let prop in doc) {
                            if (doc.hasOwnProperty(prop)) {
                                if (synerisFieldRegex.test(prop)) {
                                    let propName = prop.substring(0, prop.lastIndexOf('_')).replace(/\./g, '_');
                                    const suffix = prop[prop.lastIndexOf('_') + 1];
                                    // Multivalue?
                                    if (prop[prop.length - 1] === "m") {
                                        let val = "";
                                        for (let k = 0; k < doc[prop].length; k++) {
                                            if (k > 0)
                                                val += ";";
                                            switch (suffix) {
                                                case "b":
                                                    val += doc[prop][k] ? "Y" : "N";
                                                case "f":
                                                    val += kendo.toString(doc[prop][k], "n2");
                                                case "d":
                                                    val += kendo.toString(new Date(doc[prop][k]), "G");
                                                default:
                                                    val += doc[prop][k].toString();
                                            }
                                            item[propName] = val;
                                        }
                                    }
                                    else {
                                        item[propName] = suffix === "d" ? new Date(doc[prop]) : doc[prop];
                                    }
                                }
                            }
                        }
                        items.push(item);
                    }
                    return Promise.resolve(items);
                }
            }).then(() => {
                let fetchFields = ["id", "score", "cgdocument.docid_i", "cgdocument.instanzid_i", "cgdocument.version_i", "cgdocument.typeid_i", "cgdocument.listtextrgb_s"];
                let columns = resultContainer.synList("getColumns");
                let colfields = columns.map(col => col.dataField + that.getSuffixFromColField(col));
                $.merge(fetchFields, colfields);
                let fl = manager.store.get("fl");
                fl.val(fetchFields.join(","));
                manager.addWidget(new Core_js_1.AjaxSolr.ResultWidget({
                    id: coreName + '_results',
                    target: '#' + resultContainer.attr('id')
                }));
            });
        }
        else if (coreName === "fs") {
            let fetchFields = ["id", "score", "name", "path_path", "owner_s", "size_l", "createdate_d", "lastchangedate_d"];
            let fl = manager.store.get("fl");
            fl.val(fetchFields.join(","));
            let templateResultListWidget = require("../../../TdWebtoolkitControls/dependencies/ajax_solr/widgets/syneris/ResultListWidget.fs.tmpl.htm");
            manager.addWidget(new Core_js_1.AjaxSolr.ResultListWidget({
                id: coreName + '_results',
                target: '#' + resultContainer.attr('id'),
                listTemplate: templateResultListWidget
            }));
        }
    }
    initSolr(coreName, facetFields, maxRows) {
        const that = this;
        let manager = new Core_js_1.AjaxSolr.Manager({
            solrUrl: 'WSProxy.axd?solr=' + coreName,
            errorHandler(jqXHR, textStatus, errorThrown) {
                if (jqXHR.responseJSON)
                    alert(jqXHR.responseJSON);
                else
                    alert(jqXHR.errorThrown);
            },
            handleError(jqXHR, textStatus, errorThrown, options) {
                if (jqXHR.responseJSON) {
                    let error = {
                        ErrorDisplayMessage: Utilities_1.synUtil.Strings.getValue("searcherror"),
                        InnerError: {
                            ErrorDisplayMessage: jqXHR.responseJSON.error.msg,
                            ErrorCode: jqXHR.responseJSON.error.code
                        }
                    };
                    $.errorDialog("show", error);
                }
                else {
                    if (jqXHR.readyState === 0 || jqXHR.status === 0)
                        return;
                    else
                        alert(errorThrown);
                }
            },
            onMissingSearchConstraints() {
                Utilities_1.synUtil.Notifications.warning(Utilities_1.synUtil.Strings.getValue("searchenterkeywords"));
            }
        });
        manager.init();
        manager.store.addByValue('q', '*:*');
        let dateFacets = $.map(facetFields, (facet) => {
            return (that.getFacetWidgetType(facet) === FacetWidgetType.DateRange ? facet : undefined);
        });
        let params = {
            facet: true,
            rows: maxRows,
            'facet.field': $.map(facetFields, function (elem, idx) {
                if (elem.name.indexOf("spellcheck_") === 0)
                    return undefined;
                return elem.name;
            }),
            'facet.range': $.map(dateFacets, function (elem, idx) {
                return "{!ex=" + elem.name.replace(/[\._]/, "") + "}" + elem.name;
            }),
            'facet.mincount': 1,
            'facet.sort': 'index',
            'facet.limit': 2000,
            'json.nl': 'map'
        };
        let langCode = Utilities_1.synUtil.userLanguage.substring(0, 2);
        if (langCode) {
            for (let i = 0; i < facetFields.length; i++) {
                if (facetFields[i].name === "spellcheck_" + langCode) {
                    manager.store.get("spellcheck").val(true);
                    params["spellcheck.dictionary"] = facetFields[i].name;
                    break;
                }
            }
        }
        $.each(facetFields, (idx, facet) => {
            let prefix = "f." + facet.name + ".facet";
            if (facet.options) {
                for (let key in facet.options) {
                    if (facet.options.hasOwnProperty(key)) {
                        if (key.indexOf("groupingregex.") === 0
                            || key.indexOf("groupingdefault.") === 0
                            || key === "delimiter")
                            continue;
                        manager.store.addByValue(prefix + "." + key, facet.options[key]);
                    }
                }
            }
            if (that.getFacetWidgetType(facet) === FacetWidgetType.DateRange) {
                // Default values
                let fromDate = synerisSolrBase_js_1.dateToStringSolr(new Date(2003, 1, 1));
                let toDate = synerisSolrBase_js_1.dateToStringSolr(new Date());
                let dateGap = "+1MONTH";
                let minCount = "0";
                // Get override values from options
                if (facet.options) {
                    for (let key in facet.options) {
                        if (facet.options.hasOwnProperty(key)) {
                            if (key === "range.start")
                                fromDate = facet.options[key];
                            else if (key === "range.end")
                                toDate = facet.options[key];
                            else if (key === "range.gap")
                                dateGap = facet.options[key];
                            else if (key === "mincount")
                                minCount = facet.options[key];
                        }
                    }
                }
                manager.store.remove(prefix + ".range.start");
                manager.store.addByValue(prefix + ".range.start", fromDate);
                manager.store.remove(prefix + ".range.end");
                manager.store.addByValue(prefix + ".range.end", toDate);
                manager.store.remove(prefix + ".range.gap");
                manager.store.addByValue(prefix + ".range.gap", dateGap);
                manager.store.remove(prefix + ".mincount");
                manager.store.addByValue(prefix + ".mincount", minCount);
            }
        });
        for (let name in params)
            manager.store.addByValue(name, params[name]);
        return manager;
    }
    getFacetWidgetType(facet) {
        if (/^[a-zA-Z0-9\._]+_d[m]?$/.test(facet.name))
            return FacetWidgetType.DateRange;
        else if (/^[a-zA-Z0-9\._]+_path[m]?$/.test(facet.name))
            return FacetWidgetType.Path;
        else if (facet.isRangeFacet)
            return FacetWidgetType.NumberRange;
        return FacetWidgetType.String;
    }
    getSuffixFromColField(col) {
        let suffix = "_s";
        switch (col.dbColType) {
            case "boolean":
                suffix = "_b";
                break;
            case "date":
            case "datetime":
                suffix = "_d";
                break;
            case "digit":
                suffix = "_i";
                break;
            case "bigdigit":
                suffix = "_l";
                break;
            case "float":
                suffix = "_f";
                break;
            default:
                break;
        }
        if (col.multiValue)
            suffix += "m";
        return suffix;
    }
}
exports.facetteSearch = facetteSearch;
